module.exports = __webpack_public_path__ + "static/media/historyBackground.a5ed48d3.jpg";